module.exports = __webpack_public_path__ + "img/QF_logo@2x.27abf2c1.png";